<template>
    <div id="map">
        <DevicePopup ref="devicepopup" v-on:closePopup="closeDevicePopup" />
    </div>
</template>

<script>
import DevicePopup from "../DevicePopup";
import Task from "../../models/Task";
import DXFFile from "../../webcomponents/models/DXFFile";

import MapModel from "../../webcomponents/models/map/MapModel"
import MapTaskInfo from "../../webcomponents/models/map/MapElements/MapTaskInfo"
import MapDXF from "../../webcomponents/models/map/MapElements/MapDXF";
import MapSatellite from "../../webcomponents/models/map/MapElements/MapSatellite";
import MapDevices from "../../webcomponents/models/map/MapElements/MapDevices";
import MapMotionplan from "../../webcomponents/models/map/MapElements/MapMotionplan"
import MapPolygonSelection from "../../webcomponents/models/map/MapElements/MapPolygonSelection"
// import MapMotionplanCollection from "../../webcomponents/models/map/MapElements/MapMotionplanCollection"
import MapMotionplanCollection from "../../webcomponents/models/map/MapElements/MapWebGLMotionplanCollection"
import MapChanges from "../../webcomponents/models/map/MapElements/MapChanges";
import MapRBPProduction from "../../webcomponents/models/map/MapElements/MapRBPProduction";
import MapDiagnostics from "../../webcomponents/models/map/MapElements/MapDiagnostics";
import MapRBPDrivingLines from "../../webcomponents/models/map/MapElements/MapRBPDrivingLines"
import MapCSVNumbers from '../../webcomponents/models/map/MapElements/MapCSVNumbers';
import MapCSVPoints from '../../webcomponents/models/map/MapElements/MapCSVPoints';
import MapMotionplanDrawer from '../../webcomponents/models/map/MapElements/MapMotionplanDrawer'

import * as CONST from "../../Constants.js";
import MapSurvey from "../../webcomponents/models/map/MapElements/MapSurveyViewer";
import MapWebGLMotionplan from "../../webcomponents/models/map/MapElements/MapWebGLMotionplan.js";
import Motionplan from "../../webcomponents/models/Motionplan.js";

export default {
    name: "Map",

    components: { DevicePopup },
    data: () => ({
        devicesLoaded: false,
        task: null,
        rbploading: {
            steeringlines: true,
            improvements: true,
            proposedImprovements: true,

            motionplan: true,
            environment: true,
            contoursAndObstacles: true,
            pointNumbers: true,
            pointsAndPointNumbers: true,
            checkProduction: true,
            production: true,
            productiontable: true
        },
        surveyloading: { production: true },
        loadingCount: 0,

        getLinelogState: false,

        createMotionPlanState: false,
        createdMotionplan: null,

        motionplans: [], // [{id:123, name:"mp1", mp:"mpstring"}, {id:124, name:"mp2", mp:"mpstring"}] // current mps to draw
        editActions: [], // [{action:"connect", newMps:[123] , prevMps:[{id:124, mp:"mpstring"}]}, ] newest action at end of array

        steeringlinesUnit: null,
    }),
    props: {
        data: {
            required: false,
        },
        projection: {
            required: false,
            default: "EPSG:3857",
        },
        mapUrl: {
            required: false,
            default: "https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        },
        rbpProductionTable: {
            required: true,
        },
        loading: {
            required: false,
        }
    },
    mounted: function () {
        this.map = new MapModel();
        this.map.initialize(this.$vuetify.theme.dark, this.mapUrl, this.$projections.withSiteCal, this.projection, /*showcontrols*/ false);

        this.mapTaskInfo = new MapTaskInfo(this.map, "TASKINFO", { interactable: false, group: false, defaultOn: true }, this.map);
        this.mapDevices = new MapDevices(this.map, "DEVICES", { clickmethod: 'browser', interactable: true, group: true, defaultOn: true }, this.map);
        this.mapDiagnostics = new MapDiagnostics(this.map, "DIAGNOSTICS", { interactable: true, group: true, defaultOn: true }, this.map);
        this.mapSatellite = new MapSatellite(this.map, "SATELLITE", { interactable: true, group: true, defaultOn: false }, this.map)

        this.map.addMapElement(this.mapSatellite);
        this.map.addMapElement(this.mapDevices);
        this.map.addMapElement(this.mapTaskInfo);
        this.map.addMapElement(this.mapDiagnostics);

        this.mapTaskInfo.addLayerToMap();

        this.mapTaskInfo.addElement(new MapChanges(this.map, "CHANGES", { interactable: true, group: false, defaultOn: false }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapDXF(this.map, "ENVIRONMENT", { clickmethod: 'browser', interactable: true, group: false, defaultOn: true }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapWebGLMotionplan(this.map, "MOTIONPLAN", { clickmethod: 'browser', interactable: true, group: true, defaultOn: true }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapMotionplanCollection(this.map, "MOTIONPLANCOLLECTION", { clickmethod: 'browser', interactable: true, group: false, defaultOn: true }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapDXF(this.map, "CONTOURSANDOBSTACLES", { clickmethod: 'browser', interactable: true, group: false, defaultOn: true }, this.mapTaskInfo));


        this.mapTaskInfo.addElement(new MapRBPProduction(this.map, "RBPPRODUCTION", { clickmethod: 'browser', interactable: true, group: true, defaultOn: false }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapRBPDrivingLines(this.map, "RBPDRIVINGLINES", { interactable: true, group: true, defaultOn: false }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapDXF(this.map, "STEERINGLINES", { clickmethod: 'browser', interactable: true, group: false, defaultOn: true, actions: true }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapSurvey(this.map, "SURVEY", { interactable: true, group: true, defaultOn: true }, this.mapTaskInfo));

        this.mapTaskInfo.addElement(new MapCSVPoints(this.map, "CSVPOINTS", { interactable: true, group: true, defaultOn: true, }, this.mapTaskInfo));
        this.mapTaskInfo.addElement(new MapCSVNumbers(this.map, "CSVNUMBERS", { interactable: true, group: true, defaultOn: true, }, this.mapTaskInfo));

        // should this be in mapTaskinfo?
        this.motionplanDrawer = new MapMotionplanDrawer(this.map, "MOTIONPLANDRAWER", { interactable: false, group: true, defaultOn: true }, this.map);
        this.polygonSelection = new MapPolygonSelection(this.map, "POLYGONSELECTION", { interactable: false, group: true, defaultOn: true }, this.map);


        this.mapDevices.initializeSelect();
        this.mapDevices.addSelectEventFunction(this.deviceSelected);

        this.mapTaskInfo.getChildElement("RBPPRODUCTION").initializeSelect();
        this.mapTaskInfo.getChildElement("RBPPRODUCTION").addSelectEventFunction(this.rbpProductionSelected);

        this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").initializeSelect();
        this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").addSelectEventFunction(this.motionplanSelected);

        this.mapTaskInfo.getChildElement("STEERINGLINES").initializeSelect();
        this.mapTaskInfo.getChildElement("STEERINGLINES").addSelectEventFunction(this.selectLayerFromLine);

        this.motionplanDrawer.setTargetLayer(this.mapTaskInfo.getChildElement("STEERINGLINES").layer)
        this.polygonSelection.setTargetLayer(this.mapTaskInfo.getChildElement("STEERINGLINES").layer)
        this.polygonSelection.setCreateMotionplanFunction(this.createMotionplanFromPolygonSelection)

        this.getDeviceStatus();
        this.setProjections();
        this.setUnits();
    },
    computed: {
        customerId() {
            return this.$auth.customerId;
        },
        hasDxfConnectDisconnectLines() {
            return this.$auth.functionGroups.includes(4)
        },
        hasTracking() {
            return this.$auth.functionGroups.includes(2)
        },
        isAdmin() {
            return this.$auth.functionGroups.includes(1);
        }
    },
    watch: {
        /* only first time devices are loaded */
        devicesLoaded(val) {
            if (this.task == null && this.mapDevices.getDevices().length > 0) {
                this.map.fitExtend(this.mapDevices.getExtent(), {
                    padding: [100, 100, 100, 100],
                    maxZoom: 13,
                });
                this.$emit("updateLayerlist");
            }
        },
        /* projection is changed */
        projection(val) {
            this.map.setProjection(val);
        },
        createMotionPlanState(val) {
            if (val) {
                console.log("START CREATING MOTIONPLAN")
                //when selecting line, check if motionplan exists. 
                //if it doesnt create new one
                //if it does exist, create a new segment using the connection line and the new dxf data.

                if (this.task.operationPractice == CONST.__OP_SPRAYSTEERINGLINES) {
                    // deselect currently selected segments.
                    this.mapTaskInfo.getChildElement("STEERINGLINES").unselectAll()
                    this.$emit('setActiveLayer', null);

                    this.motionplanDrawer.setTargetLayer(this.mapTaskInfo.getChildElement("STEERINGLINES").layer)
                    this.polygonSelection.setTargetLayer(this.mapTaskInfo.getChildElement("STEERINGLINES").layer)

                    this.mapTaskInfo.getChildElement("STEERINGLINES").addSelectEventFunction(this.lineSelectedCreateMotionplan);
                    this.mapTaskInfo.getChildElement("STEERINGLINES").toggleCreateMotionplanSelectStyle(true)
                } else if (this.task.operationPractice == CONST.__OP_MOTIONPLAN) {
                    console.log("SET SELECT ON ENVIRONMENT")
                    this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").removeSelect()

                    this.motionplanDrawer.setTargetLayer(this.mapTaskInfo.getChildElement("ENVIRONMENT").layer)
                    this.polygonSelection.setTargetLayer(this.mapTaskInfo.getChildElement("ENVIRONMENT").layer)

                    this.mapTaskInfo.getChildElement("ENVIRONMENT").initializeSelect();
                    this.mapTaskInfo.getChildElement("ENVIRONMENT").addSelectEventFunction(this.lineSelectedCreateMotionplan);
                    this.mapTaskInfo.getChildElement("STEERINGLINES").toggleCreateMotionplanSelectStyle(true)
                    this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").hide()
                    this.$emit("updateLayerlist");
                }
            } else {
                console.log("STOP CREATING MOTIONPLAN")

                this.mapTaskInfo.getChildElement("STEERINGLINES").addSelectEventFunction(this.selectLayerFromLine);
                this.mapTaskInfo.getChildElement("ENVIRONMENT").addSelectEventFunction(null);

                this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").initializeSelect() // on init reset previous init
                this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").showChildren()
                this.$emit("updateLayerlist");

                this.mapTaskInfo.getChildElement("STEERINGLINES").toggleCreateMotionplanSelectStyle(false)
                this.mapTaskInfo.getChildElement("ENVIRONMENT").removeSelect()
            }
        },
        getLinelogState(val) {
            if (val) {
                this.mapTaskInfo.getChildElement("STEERINGLINES").addSelectEventFunction(this.lineSelectedGetLinelog);
            } else {
                this.mapTaskInfo.getChildElement("STEERINGLINES").addSelectEventFunction(this.selectLayerFromLine);
            }
        },
        rbploading: {
            handler(val) {
                if (this.loading) this.loading.addProgress(100 / this.loadingCount);

                if (val.steeringlines &&
                    val.improvements &&
                    val.proposedImprovements &&
                    val.motionplan &&
                    val.environment &&
                    val.contoursAndObstacles &&
                    val.pointNumbers &&
                    val.pointsAndPointNumbers &&
                    val.checkProduction &&
                    val.production &&
                    val.productiontable) {
                    if (this.loading) {
                        this.loading.setText(this.language.t("Map.finishedLoading"));
                        this.loading.progress = 100
                        setTimeout(() => {
                            this.loading.hide();
                        }, 1000)
                    }
                }
                if (val.steeringlines && val.motionplan) {
                    if (this.loading) this.loading.minimize();
                }
                // DECIDE LOADING/DRAWING ORDER HERE
                if (val.steeringlines ||
                    val.improvements ||
                    val.proposedImprovements ||
                    val.motionplan ||
                    val.environment ||
                    val.contoursAndObstacles ||
                    val.pointNumbers ||
                    val.pointsAndPointNumbers ||
                    val.checkProduction ||
                    val.production ||
                    val.productiontable) {
                    this.$emit("updateLayerlist");
                    if (!val.steeringlines) {
                        if (this.loading) this.loading.setText(this.language.t("Map.drawSteeringlines"));
                        this.openSteeringlines();
                        return;
                    }
                    if (!val.improvements) {
                        if (this.loading) this.loading.setText(this.language.t("Map.getDxfImprovements"));
                        this.getImprovements();
                        return;
                    }
                    if (!val.proposedImprovements) {
                        if (this.loading) this.loading.setText(this.language.t("Map.getDxfImprovements"));
                        this.getProposedImprovements();
                        return;
                    }
                    if (!val.pointsAndPointNumbers) {
                        if (this.loading) this.loading.setText(this.language.t("Map.loadingPointsAndPointNumbers"));
                        this.drawPointsAndPointNumbers();
                        return;
                    }
                    if (!val.environment) {
                        if (this.loading) this.loading.setText(this.language.t("Map.loadingEnvironmentModel"));
                        this.openEnvironment();
                        return;
                    }
                    if (!val.contoursAndObstacles) {
                        if (this.loading) this.loading.setText(this.language.t("Map.loadingContoursAndObstacles"));
                        this.openContoursAndObstacles();
                        return;
                    }
                    if (!val.motionplan) {
                        if (this.loading) this.loading.setText(this.language.t("Map.loadMotionplanCollection")); //TODO translation
                        this.loadMotionplanCollection();
                        return;
                    }
                    if (!val.pointNumbers) {
                        if (this.loading) this.loading.setText(this.language.t("Map.loadingPointNumbers"));
                        this.drawPointNumbers();
                        return;
                    }
                    if (!val.checkProduction) {
                        if (this.loading) this.loading.setText(this.language.t("Map.checkProduction"));
                        this.checkRBPProduction();
                        return;
                    }
                    if (!val.production) {
                        if (this.loading) this.loading.setText(this.language.t("Map.drawProduction"));
                        this.getRBPProduction();
                        return;
                    }
                    if (!val.productiontable) {
                        if (this.loading) this.loading.setText(this.language.t("Map.fillProductionTable"));
                        this.getRBPProductionTable();
                        return;
                    }
                }
            },
            deep: true,
        },
    },
    methods: {
        setPolygonSelectionState(state) {
            // now selecting using polygon so not using standard method so disable this
            if (state) {
                this.mapTaskInfo.getChildElement("STEERINGLINES").removeSelect()
                this.mapTaskInfo.getChildElement("ENVIRONMENT").removeSelect()
                this.polygonSelection.setSelectState(state)
                this.motionplanDrawer.clearLine()
            } else { // go back to standard motionplan selecting
                this.mapTaskInfo.getChildElement("ENVIRONMENT").initializeSelect();
                this.mapTaskInfo.getChildElement("STEERINGLINES").initializeSelect();
                this.polygonSelection.setSelectState(state)
            }
        },
        createMotionplanFromPolygonSelection(selectedFeatures) {
            console.log(selectedFeatures)

            if (selectedFeatures.length > 0) {
                const DXFDATA = []
                selectedFeatures.forEach(feature => {
                    this.mapTaskInfo.getChildElement("STEERINGLINES").select(feature)
                    DXFDATA.push({ layer: structuredClone(feature.get('dxfData')) })
                })

                let data = new FormData();

                console.log(JSON.stringify(DXFDATA))
                data.set('lines', JSON.stringify(DXFDATA));
                data.set('type', "RBP");

                this.$axios.post(route('api.motionplan.multi.post'), data, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((res) => {
                        console.log(res)
                        this.$emit("createMotionplan", res.data, DXFDATA[0].layer.handle)

                        this.mapTaskInfo.getChildElement("MOTIONPLAN").drawLayer(this.createdMotionplan, this.task.projection);

                        this.$emit("updateLayerlist");
                    })
            }

            this.$nextTick(() => {
                this.setPolygonSelectionState(false)
            })
        },
        toggleMotionplanEditor(state) {
            if (state) {
                // check if a motionplan is selected, if one is selected open this one for editing. else open first one
                const selectedMotionplan = this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").selectedMotionplan;

                if (selectedMotionplan) {
                    console.log(selectedMotionplan)
                    this.openSegmentEditor(selectedMotionplan, 0)
                } else {
                    this.openSegmentEditor(this.motionplans[0].id, 0)
                }
            } else {
                this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").addSelectEventFunction(this.motionplanSelected);
            }
        },
        setConnectState(mp1, reversed, x, y) {
            console.log("CONNECT")
            this.motionplanDrawer.setTargetLayer(this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").layer)
            // this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").mapElements.forEach(mapElement => {
            //     mapElement.show()
            //     mapElement.combineFeatures();
            // });

            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").combineFeatures();
            this.$emit("updateLayerlist");
            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").selectMotionplan(mp1.id)
            this.drawMotionplanDrawlineFromPoint(x, y)
            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").addSelectEventFunction((event) => this.lineSelectedCombineMotionplans(event, mp1, reversed));
        },
        undoConnectState() {
            this.openMotionplanCollection()
            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").addSelectEventFunction(this.motionplanSelected);
            this.motionplanDrawer.setTargetLayer(this.mapTaskInfo.getChildElement("STEERINGLINES").layer) // TODO: set to null
            this.motionplanDrawer.clearLine()
        },
        refreshProjections() {
            this.map.setProjections(this.$projections.withSiteCal);
        },
        selectLayerFromLine(selectEvent) {
            if (selectEvent.selected.length == 0) {
                this.$emit('setActiveLayer', null);
            } else {
                var dxfData = selectEvent.selected[0].get('dxfData');
                this.$emit('setActiveLayer', 'STEERINGLINES-' + dxfData.layer);
            }
        },
        colorSelectedLayer(layer, selected) {
            var steeringlinesElement = this.mapTaskInfo.getChildElement("STEERINGLINES");
            var layerElement = steeringlinesElement.mapElements.find(mapElement => mapElement.id == layer);
            layerElement.colorSelectedLayer(selected)
        },
        setProjections() {
            this.$axios.get(route("api.projections")).then(res => {
                this.$projections.setProjections(res.data);
                this.map.setProjections(this.$projections.withSiteCal);
                this.setCustomerProjections();
            });
        },
        setUnits() {
            this.$axios.get(route("api.dxfunits")).then(res => {
                this.$units.setUnits(res.data);
                console.log(this.$units);
            });
        },
        async setCustomerProjections() {
            const { data: customers } = await this.$axios.get(route("api.customer.customerProjections", this.customerId))
            var result = this.$projections.all.filter(projection => {
                var included = false;
                customers.forEach(customerProjection => {
                    if (customerProjection.projection_id == projection.projectionId) included = true;
                });
                return included;
            });
            this.$projections.setCustomerProjections(result);
            this.$projections.setDefaultProjectionId(0);
            customers.forEach(customerProjection => {
                if (customerProjection.default_projection == 1) {
                    this.$projections.setDefaultProjectionId(customerProjection.projection_id)
                }
            })
        },
        drawAdminDiagnostics(data, projection, fitExtend) { //only vct ?
            this.mapDiagnostics.drawLayer(data, projection);
            if (fitExtend)
                this.map.fitExtend(this.mapDiagnostics.getExtent(), { padding: [0, 0, 0, 0], maxZoom: 20 });

            this.$emit("updateLayerlist");
            console.log("drawdiagnostics done");
        },
        clearAdminDiagnostics() {
            this.mapDiagnostics.clear();
        },
        closeDevicePopup() {
            this.map.deviceOverlay.setPosition(undefined);
            this.deselectDevice();
        },
        openTask(task) {
            this.mapTaskInfo.addLayerToMap();
            this.$emit("onRemoveAlert", "opentask");
            this.task = new Task(task);

            switch (this.task.operationPractice) {
                case CONST.__OP_SPRAYSTEERINGLINES:
                case CONST.__OP_SPRAYPOINTS:
                case "MotionplanSprayPoints": //TODO: ADD TO CONSTANTS
                case "MotionplanSprayPointsWithBoundary":
                case CONST.__OP_MOTIONPLAN:
                    console.info(`Open ${this.task.operationPractice}`);
                    if (this.loading) this.loading.show();
                    this.openRBPTask();
                    break;
                case CONST.__OP_SURVEY:
                    if (this.loading) this.loading.show();
                    this.openSurvey();
                    break;
                default:
                    console.error(`Could not open task for operation practice ${this.task.operationPractice}`);
                    break;
            }
        },
        closeTask() {
            console.log("closing task");
            this.toggleMotionplanEditor(false)
            this.task = null;
            this.unsetLocalProjection();
            if (this.loading) this.loading.hide();
            this.mapTaskInfo.clear();

            if (this.rbpProductionTable) this.rbpProductionTable.empty();
            this.$emit("updateLayerlist");
            this.$emit("closeMotionplanEditor");
            this.$emit('setActiveLayer', null);
            console.log("task closed");


            this.motionplans = []
            this.editActions = []
            this.steeringlinesUnit = null;
        },
        lineSelectedSendLineData(selectEvent) {
            if (selectEvent.selected.length == 0) {
                this.$emit('setLineData', null, null);
            } else {
                var dxfData = selectEvent.selected[0].get('dxfData');

                var postData = { lineData: { layerName: dxfData.layer, handle: dxfData.handle } };

                this.$emit('setLineData', postData, this.task.taskId);
            }
        },
        lineSelectedGetLinelog(selectEvent) {
            if (selectEvent.selected.length > 0) {

                const DXFDATA = structuredClone(selectEvent.selected[0].get('dxfData'));

                let data = new FormData();

                data.set('line', JSON.stringify(DXFDATA));
                this.$axios.post(route('api.linelog.post'), data, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((res) => {
                        const csvBlob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
                        const url = URL.createObjectURL(csvBlob);
                        const link = document.createElement('a');
                        link.style.display = 'none';
                        link.href = url;
                        link.download = "LINELOG" + '.log';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);

                        this.getLinelogState = false;
                    })
            }
        },
        lineSelectedCombineMotionplans(selectEvent, mp1, mp1Reversed) {
            const coordinate = selectEvent.mapBrowserEvent.coordinate; // Get the cursor's coordinates from the event

            if (selectEvent.selected.length > 0) {
                this.motionplanDrawer.clearLine()

                if (selectEvent.selected[0].getGeometry().getType() == "Point") {
                    this.motionplanDrawer.drawLoadingLine(selectEvent.selected[0].getGeometry().getCoordinates())

                    this.$emit("combineMotionplans", mp1, selectEvent.selected[0].get('motionplan'), mp1Reversed, false)
                } else {
                    this.motionplanDrawer.drawLoadingLine(this.motionplanDrawer.findClosestEndPoint(selectEvent.selected[0].getGeometry(), coordinate))

                    // first motionplan segment should start at end rest of the segments start at start (first click at end rest click at start)
                    const mp2Reversed = !this.motionplanDrawer.isStartSelected(selectEvent.selected[0].getGeometry(), coordinate)

                    this.$emit("combineMotionplans", mp1, selectEvent.selected[0].get('motionplan'), mp1Reversed, mp2Reversed)
                }

            }
            if (selectEvent.deselected.length > 0) {
                this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").selectMotionplan(mp1.id)
            }
        },
        lineSelectedCreateMotionplan(selectEvent) {
            const coordinate = selectEvent.mapBrowserEvent.coordinate; // Get the cursor's coordinates from the event

            if (selectEvent.selected.length > 0) {
                this.motionplanDrawer.clearLine()

                let startCoordinates = null
                if (this.createdMotionplan) {
                    startCoordinates = this.motionplanDrawer.findFurthestEndpoint(selectEvent.selected[0].getGeometry(), coordinate)
                    this.motionplanDrawer.drawLoadingLine(this.motionplanDrawer.findClosestEndPoint(selectEvent.selected[0].getGeometry(), coordinate))
                } else {
                    startCoordinates = this.motionplanDrawer.findClosestEndPoint(selectEvent.selected[0].getGeometry(), coordinate)
                }

                // needs to be done after the reselect is done or it will snap to selected features
                this.$nextTick(() => {
                    this.motionplanDrawer.drawLine(startCoordinates)
                })

                // first motionplan segment should start at end rest of the segments start at start (first click at end rest click at start)
                const reverse = !this.motionplanDrawer.isStartSelected(selectEvent.selected[0].getGeometry(), coordinate)

                const DXFDATA = structuredClone(selectEvent.selected[0].get('dxfData'));

                let data = new FormData();
                // motionplan exists so if reverse is true we should reverse dxf data
                // first segment should always be reversed unless its selected in reverse.
                if ((this.createdMotionplan && reverse) || (!this.createdMotionplan && !reverse)) {
                    data.set('reversed', 1);
                } else {
                    data.set('reversed', 0);
                }

                console.log(JSON.stringify(DXFDATA))
                data.set('line', JSON.stringify(DXFDATA));
                data.set('type', "RBP");
                this.$axios.post(route('api.motionplan.post'), data, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((res) => {
                        this.motionplanDrawer.clearLine()
                        this.motionplanDrawer.drawLine(startCoordinates)
                        this.$emit("createMotionplan", res.data, DXFDATA.handle)

                        this.mapTaskInfo.getChildElement("MOTIONPLAN").drawLayer(this.createdMotionplan, this.task.projection);

                        this.$emit("updateLayerlist");
                    })
            }
            if (selectEvent.deselected.length > 0) {
                selectEvent.deselected.forEach(feature => {
                    if (this.task?.operationPractice == CONST.__OP_SPRAYSTEERINGLINES) {
                        this.mapTaskInfo.getChildElement("STEERINGLINES").select(feature)
                    } else {
                        this.mapTaskInfo.getChildElement("ENVIRONMENT").select(feature)
                    }
                });
            }
        },
        resetMotionplanCreator() {
            this.motionplanDrawer.clearLine()
            this.mapTaskInfo.getChildElement("MOTIONPLAN").clear()
            this.mapTaskInfo.getChildElement("STEERINGLINES").deselect()
            this.mapTaskInfo.getChildElement("ENVIRONMENT").deselect()
            this.$emit("updateLayerlist");
        },
        redrawMotionplan() {
            this.mapTaskInfo.getChildElement("MOTIONPLAN").drawLayer(this.createdMotionplan, this.task.projection);
            this.$emit("updateLayerlist");
        },
        deselectFeatureFromHandle(handle) {
            this.mapTaskInfo.getChildElement("STEERINGLINES").deselectFeatureFromHandle(handle)
            this.mapTaskInfo.getChildElement("ENVIRONMENT").deselectFeatureFromHandle(handle)
        },
        drawMotionplanDrawlineFromPoint(x, y) {
            this.motionplanDrawer.clearLine()
            this.motionplanDrawer.drawLineFromMotionplanPoint({ x: x, y: y }, this.task.projection);
        },
        motionplanSelected(selectEvent) {
            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").unselectAll();
            console.log(selectEvent)
            if (selectEvent.selected.length != 0) {
                const selectedFeature = selectEvent.selected[0]

                console.log(selectedFeature.get("motionplanElementId"))
                this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").selectMotionplan(selectedFeature.get("motionplanElementId"));

                // set active layer
                this.$emit('setActiveLayer', "MOTIONPLANCOLLECTION-" + selectedFeature.get("motionplanElementId"));
            } else {
                this.$emit('setActiveLayer', null);
            }
        },
        segmentSelected(selectEvent) {
            console.log(selectEvent)

            if (selectEvent.selected.length != 0) {
                const selectedFeature = selectEvent.selected[0]

                this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").unselectAll();

                if (selectedFeature.getKeys().some(e => e == "motionplanSegmentIndex")) {
                    this.openSegmentEditor(selectedFeature.get("motionplanElementId"), selectedFeature.get("motionplanSegmentIndex"));
                } else {
                    const motionplanElement = this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").findMotionplanElement(selectedFeature.get("motionplanElementId"))

                    const coordinates = selectEvent.mapBrowserEvent.coordinate

                    // const transformed = proj4.transform(this.map.projection, this.task.projection, [coordinates.x, coordinates.y]);

                    this.openSegmentEditor(selectedFeature.get("motionplanElementId"), motionplanElement.getFeatureFromPoint(coordinates).get("motionplanSegmentIndex"));
                }
            } else {
                const deselectedFeature = selectEvent.deselected[0]
                const motionplanElement = this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").findMotionplanElement(deselectedFeature.get("motionplanElementId"))

                motionplanElement.selectSegment(deselectedFeature.get("motionplanSegmentIndex"))
            }
        },
        openSegmentEditor(motionplanElementId, segmentIndex) {
            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").addSelectEventFunction(this.segmentSelected);
            const motionplanElement = this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").findMotionplanElement(motionplanElementId)
            if (segmentIndex !== null) {
                this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").unselectAll();
                motionplanElement.selectSegment(segmentIndex);

                this.$emit("mapMotionplanEditor", motionplanElement.motionplan, segmentIndex);

                this.$emit("hideTaskInfoAndLayerlist");
                // hide other motionplan elements


                this.mapTaskInfo.getChildElement("ENVIRONMENT").hide();
                motionplanElement.show();
                this.$emit("updateLayerlist");
            }
        },
        motionplanEditorClosed() {
            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").unselectAll();
            this.mapTaskInfo.showChildren()
            this.$emit("updateLayerlist");

            this.$emit("showTaskInfoAndLayerlist");

            this.toggleMotionplanEditor(false)
        },
        updateMotionplan(id, segmentIndex = null) {
            const motionplanElement = this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").findMotionplanElement(id)
            motionplanElement.draw();

            if (segmentIndex !== null) {
                motionplanElement.selectSegment(segmentIndex);
            }
        },
        rbpProductionSelected(selectEvent) {
            if (selectEvent.deselected != 0) this.rbpProductionTable.deselectRow();
            if (selectEvent.selected != 0) {
                this.rbpProductionTable.setSelectedFromLine(selectEvent.selected["0"].values_.name);
            }
        },
        selectRBPProductionFromList(id) { // get extend?
            this.mapTaskInfo.getChildElement("RBPPRODUCTION").SelectFeatureFromList(id);
        },
        deviceSelected(selectEvent) {
            if (selectEvent.selected.length != 0) {
                this.$refs.devicepopup.setDeviceData(selectEvent.selected[0].get('deviceData'));
                this.map.showPopup(selectEvent.selected[0].getGeometry().getCoordinates());
            }
        },
        deselectDevice() {
            this.mapDevices.clearSelectedDevices();
            this.getDeviceStatus();
        },
        getDeviceStatus() {
            if (this.isAdmin){
                this.$axios.get(route("api.devices.map")).then((res) => {
                    this.mapDevices.clear();

                    if (res.data === 'No devices') return;
                    res.data.forEach((device) => {
                        if (device.locationLongitude != 0)
                            this.mapDevices.addDevice(
                                device.accountId,
                                device.deviceSerialNumberComplete,
                                {designator:""},
                                device.locationLongitude,
                                device.locationLatitude,
                                true
                            );
                    });

                    this.devicesLoaded = true;
                });
                return;
            }


            this.$axios.get(route("api.devices.status")).then((res) => {
                this.mapDevices.clear();

                if (res.data === 'No devices') return;
                res.data.forEach((device) => {
                    if (device.latest_activity.locationLongitude != null)
                        this.mapDevices.addDevice(
                            device.accountId,
                            device.deviceSerialNumberComplete,
                            device,
                            device.latest_activity.locationLongitude,
                            device.latest_activity.locationLatitude,
                            device.latest_activity.online
                        );
                });

                this.devicesLoaded = true;
            });
            // get status every minute
            setTimeout(
                function () {
                    this.getDeviceStatus();
                }.bind(this),
                60 * 1000
            );
        },
        dxfDrawerCallback(error, entity) {
            this.$emit("onAddAlert", "opentask", this.language.t("Map.dxfElementsAlert"), "warning", true); // add translation
        },
        setToLocalProjection() {
            this.map.hideMapLayer();
            this.mapDevices.hide();
            this.mapSatellite.hide();
            this.mapDevices.mapElementSettings.interactable = false;
            this.mapSatellite.mapElementSettings.interactable = false;
            this.$emit("updateLayerlist");
        },
        unsetLocalProjection() {
            this.map.showMapLayer();
            this.mapDevices.mapElementSettings.interactable = true;
            this.mapSatellite.mapElementSettings.interactable = true;
            this.$emit("updateLayerlist");
            this.map.fitExtend(this.mapDevices.getExtent(), {
                padding: [100, 100, 100, 100],
                maxZoom: 13,
            });
        },
        openSteeringlines() {
            // DXF
            console.log("open steeringline");
            var dxffile = this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_STEERINGLINE);
            var hasCSV = this.task.getFileId(CONST.__RESOURCETYPE_CSV, CONST.__IDENTIFIERTYPE_SPRAYPOINTS) ? true : false;

            if (dxffile == null) {
                console.error("Could not find dxffile");
                this.$emit("onAddAlert", "opentask", this.language.t("Map.dxfAlert"), "warning", true);
                this.rbploading.steeringlines = true;
                return;
            }

            this.$axios
                .get(route("api.tasks.dxf.download", dxffile))
                .then((res) => {
                    try {
                        const dxf = new DXFFile(res.data);
                        this.steeringlinesUnit = this.$units.fromId(dxf.parsed.header.insUnits)
                        this.$emit("currentUnit", this.steeringlinesUnit.name);
                        const conversion = this.steeringlinesUnit.conversion;
                        dxf.convertDXF(conversion)

                        console.log('has CSV:' + hasCSV);
                        this.mapTaskInfo.getChildElement("STEERINGLINES").drawLayer(dxf, this.task.projection, hasCSV ? 'spraypoints' : 'robotplotter', this.dxfDrawerCallback);
                        this.map.fitExtend(this.mapTaskInfo.getExtent());
                    } catch (e) {
                        this.$emit("onAddAlert", "opentask", this.language.t("Map.steeringlinesAlert"), "warning", true);
                        console.error(e);
                    }
                    this.rbploading.steeringlines = true;
                })
                .catch((error) => {
                    console.error(error);
                    this.rbploading.steeringlines = true;
                });
        },
        loadMotionplanCollection() {
            console.log("load MotionplanCollection")
            this.rbploading.motionplan = false;
            var motionplanCollection = this.task.getResourceSet(CONST.__RESOURCETYPE_MOTIONPLAN);

            // add check if it contains valid identifiers
            if (!motionplanCollection || !motionplanCollection.some(motionplan => motionplan.identifierType == CONST.__IDENTIFIERTYPE_MOTIONPLAN)) {
                this.rbploading.motionplan = true;
                // this.$emit("onAddAlert", "opentask", "no motionplans found", "warning", true);
            }

            var mpsLoading = 0

            motionplanCollection.forEach(motionplan => {
                if (motionplan.identifierType != CONST.__IDENTIFIERTYPE_MOTIONPLAN)
                    return;

                mpsLoading++
                this.$axios
                    .get(route("api.tasks.dxf.download", motionplan.dxffile[0].dxffileId), {
                        headers: {
                            'Cache-Control': 'no-cache, no-store, must-revalidate',
                            'Pragma': 'no-cache',
                            'Expires': '0'
                        }
                    })
                    .then((res) => {
                        this.motionplans.push({ id: motionplan.dxffile[0].dxffileId, name: motionplan.layerName, mp: res.data })
                        loaded()
                    })
                    .catch((error) => {
                        console.error(error);
                        loaded()
                    });
            });

            const loaded = () => {
                console.log("done loading motionplan")
                mpsLoading--
                console.log("mps to load: " + mpsLoading)
                if (mpsLoading == 0) {
                    this.rbploading.motionplan = true;
                    this.openMotionplanCollection()
                    this.map.fitExtend(this.mapTaskInfo.getExtent());
                }
            }
        },
        openMotionplanCollection() {
            console.log("open MotionplanCollection")

            console.log("clear MOTIONPLANCOLLECTION")
            const visibleMps = this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").getVisibleMotionplans();
            console.log(visibleMps)
            console.log(this.motionplans)

            this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").clear()

            const mpsInTask = [] // only ids
            this.task.getResourceSet(CONST.__RESOURCETYPE_MOTIONPLAN)?.forEach(resource => {
                if (resource.identifierType == CONST.__IDENTIFIERTYPE_MOTIONPLAN) {
                    mpsInTask.push(resource.dxffile[0].dxffileId)
                }
            })

            this.motionplans.forEach(motionplan => {
                console.log("Add motionplan")

                var visible = visibleMps.includes(motionplan.id)

                console.log("visible: ")
                console.log(visible)

                const mp = new Motionplan(motionplan.mp, motionplan.id, motionplan.name)
                console.log(mp.Unit)

                const unit = this.$units.fromId(mp.Unit)

                if (!this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_ENVIRONMENT)) {
                    console.log("NO DXF FILE CHANGE TO MOTIONPLAN UNIT")
                    this.$emit("currentUnit", unit.name);
                }

                // const conversion = unit.conversion;
                // mp.convert(conversion)



                if (!mpsInTask.some(mpId => mpId == motionplan.id)) { // new mps 
                    this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").addMotionplan(mp, this.task.projection, true, false);
                } else {
                    this.mapTaskInfo.getChildElement("MOTIONPLANCOLLECTION").addMotionplan(mp, this.task.projection, true);
                }
            });

            console.log("done drawing motionplans")
            this.$emit("updateLayerlist");
        },
        openEnvironment() {
            var environment = this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_ENVIRONMENT);
            if (environment) {
                this.$axios.get(route("api.tasks.dxf.download", environment)).then(res => {

                    const dxf = new DXFFile(res.data);
                    const unit = this.$units.fromId(dxf.parsed.header.insUnits)
                    console.log(dxf)
                    this.$emit("currentUnit", unit.name);
                    const conversion = unit.conversion;
                    dxf.convertDXF(conversion)

                    var environmentElement = this.mapTaskInfo.getChildElement("ENVIRONMENT");

                    //        steeringlines  dxf, this.task.projection, hasCSV ? 'spraypoints' : 'robotplotter', this.dxfDrawerCallback
                    environmentElement.drawLayer(dxf, this.task.projection, 'robotplotter', this.dxfDrawerCallback);
                    this.map.fitExtend(this.mapTaskInfo.getExtent());
                    this.rbploading.environment = true;
                }).catch((error) => {
                    console.error(error);
                    this.rbploading.environment = true;
                });
            } else {
                // no environment layer available
                this.rbploading.environment = true;
            }
        },
        openContoursAndObstacles() {
            var file = this.task.getFileId(CONST.__RESOURCETYPE_DXF, "__IDENTIFIERTYPE_CONTOURANDOBSTACLE");
            if (file) {
                this.$axios.get(route("api.tasks.dxf.download", file)).then(res => {
                    const dxf = new DXFFile(res.data);
                    const unit = this.$units.fromId(dxf.parsed.header.insUnits)
                    this.$emit("currentUnit", unit.name);
                    const conversion = unit.conversion;
                    dxf.convertDXF(conversion)

                    var mapElement = this.mapTaskInfo.getChildElement("CONTOURSANDOBSTACLES");

                    mapElement.drawLayer(dxf, this.task.projection, 'robotplotter', this.dxfDrawerCallback);
                    this.map.fitExtend(this.mapTaskInfo.getExtent());
                    this.rbploading.contoursAndObstacles = true;
                }).catch((error) => {
                    console.error(error);
                    this.rbploading.contoursAndObstacles = true;
                });
            } else {
                this.rbploading.contoursAndObstacles = true;
            }
        },
        drawPointNumbers() {
            var points = this.task.getFileId(CONST.__RESOURCETYPE_CSV, CONST.__IDENTIFIERTYPE_SPRAYPOINTS);
            if (!points) {
                this.rbploading.pointNumbers = true;
                return;
            }

            this.$axios.get(route("api.tasks.dxf.download", points)).then(res => {
                const lines = res.data
                    .replaceAll('\r', '')
                    .trim()
                    .split("\n")
                    .map((item) => item.split(','));
                this.mapTaskInfo.getChildElement("CSVNUMBERS").drawLayer(lines, this.task.projection, "right");
                this.rbploading.pointNumbers = true;
                this.$emit("updateLayerlist");
            }).catch((error) => {
                console.error(error);
                this.rbploading.pointNumbers = true;
            });
        },
        drawPointsAndPointNumbers() {
            var points = this.task.getFileId(CONST.__RESOURCETYPE_CSV, CONST.__IDENTIFIERTYPE_SPRAYPOINTS);
            if (!points) {
                this.rbploading.pointsAndPointNumbers = true;
                return;
            }

            this.$axios.get(route("api.tasks.dxf.download", points)).then(res => {
                const lines = res.data
                    .replaceAll('\r', '')
                    .trim()
                    .split("\n")
                    .map((item) => item.split(','));

                this.mapTaskInfo.getChildElement("CSVNUMBERS").defaultOn = false;
                this.mapTaskInfo.getChildElement("CSVNUMBERS").drawLayer(lines, this.task.projection, "right");

                this.mapTaskInfo.getChildElement("CSVPOINTS").drawLayer(lines, this.task.projection);


                this.rbploading.pointsAndPointNumbers = true;
                this.$emit("updateLayerlist");
            }).catch((error) => {
                console.error(error);
                this.rbploading.pointsAndPointNumbers = true;
            });
        },
        getImprovements() {
            console.log("get improvements");
            var dxffile = this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_STEERINGLINE);

            if (dxffile == null) {
                console.error("Could not find dxffile");
                this.$emit("onAddAlert", "opentask", this.language.t("Map.dxfAlert"), "warning", true);
                this.rbploading.improvements = true;
                return;
            }

            this.$axios.get(route("api.tasks.dxf.json", dxffile)).then((res) => {
                if (res.data.hasOwnProperty("actions")) {
                    this.rbploading.improvements = true;
                } else {
                    try {
                        res.data.forEach((changedata) => {
                            let hasChanges = false;

                            changedata.actions.forEach(action => {
                                if ((action.action == "connectlines" && action.changes.length > 0) || (action.action == "disconnectlines" && action.changes.length > 0)) {
                                    hasChanges = true
                                }
                            })

                            console.log(this.steeringlinesUnit.conversion)


                            if (this.steeringlinesUnit && this.steeringlinesUnit.conversion != 1) {

                                changedata.actions.forEach(action => {
                                    action.changes.forEach(change => {
                                        change.start.x *= this.steeringlinesUnit.conversion;
                                        change.start.y *= this.steeringlinesUnit.conversion;
                                    })
                                })
                            }

                            if (hasChanges) this.mapTaskInfo.getChildElement("CHANGES").drawLayer(changedata, this.task.projection);
                        });

                    } catch (error) {
                        console.log(error)
                    }
                    this.rbploading.improvements = true;
                }
            }).catch((error) => {
                console.error(error);
                this.rbploading.improvements = true;
            });
        },
        getProposedImprovements() {
            this.mapTaskInfo.getChildElement("CHANGES").disabled = true;

            var dxffile = this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_PROPOSEDUPDATE);

            if (dxffile == null) {
                console.error("Could not find dxffile");
                this.$emit("onAddAlert", "opentask", this.language.t("Map.dxfAlert"), "warning", true);
                this.rbploading.proposedImprovements = true;
                return;
            }
            this.$axios.get(route("api.tasks.dxf.json", dxffile)).then((res) => {
                if (res.data.hasOwnProperty("actions")) {
                    this.rbploading.proposedImprovements = true;
                } else {
                    try {
                        res.data.forEach((changedata) => {
                            let hasChanges = false;
                            changedata.actions.forEach(action => {
                                if ((action.action == "connectlines" && action.changes.length > 0) || (action.action == "disconnectlines" && action.changes.length > 0)) {
                                    hasChanges = true
                                }
                            })
                            if (hasChanges) this.mapTaskInfo.getChildElement("CHANGES").drawLayer(changedata, this.task.projection);
                        });

                    } catch (error) {
                        console.log(error)
                    }
                    this.rbploading.proposedImprovements = true;
                }
            }).catch((error) => {
                console.error(error);
                this.rbploading.proposedImprovements = true;
            });;
        },
        openRBPTask() {
            this.loadingCount = 0;
            // all elements of a task for each functiongroup
            this.rbploading.checkProduction = false;
            this.loadingCount += 1;

            if (this.task.projection == "LOCAL") {
                this.setToLocalProjection();
            }

            if (this.task.operationPractice == CONST.__OP_MOTIONPLAN) {
                this.rbploading.environment = false;
                this.rbploading.motionplan = false;

                this.loadingCount += 2;
            } else if (this.task.operationPractice == CONST.__OP_SPRAYSTEERINGLINES) {
                this.rbploading.steeringlines = false;
                // improvements if has group 4 
                // no proposedImprovements if motionplan?


                if (this.hasDxfConnectDisconnectLines) {
                    this.rbploading.improvements = false;
                } else {
                    this.rbploading.proposedImprovements = false;
                }
                this.loadingCount += 2;
            } else if (this.task.operationPractice == CONST.__OP_SPRAYPOINTS ||
                this.task.operationPractice == "MotionplanSprayPoints" ||
                this.task.operationPractice == "MotionplanSprayPointsWithBoundary") { // split into two: one with spraypoints mps and other with spraypoint dxfs
                // steeringlines can have multiple variants
                this.rbploading.steeringlines = !this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_STEERINGLINE);
                this.rbploading.environment = !this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_ENVIRONMENT);
                this.rbploading.contoursAndObstacles = !this.task.getFileId(CONST.__RESOURCETYPE_DXF, "__IDENTIFIERTYPE_CONTOURANDOBSTACLE");
                this.rbploading.motionplan = !this.task.hasResourceSet(CONST.__RESOURCETYPE_MOTIONPLAN);

                !this.rbploading.steeringlines ? ++this.loadingCount : null;
                !this.rbploading.environment ? ++this.loadingCount : null;
                !this.rbploading.contoursAndObstacles ? ++this.loadingCount : null;
                !this.rbploading.motionplan ? ++this.loadingCount : null; // two stage loading?


                if (this.task.operationPractice == CONST.__OP_SPRAYPOINTS) {
                    this.rbploading.pointNumbers = false;
                    this.loadingCount += 1;
                } else {
                    this.rbploading.pointsAndPointNumbers = false;
                    this.loadingCount += 1;
                }

                // improvements if has group 4 
                if (this.hasDxfConnectDisconnectLines) {
                    this.rbploading.improvements = !this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_STEERINGLINE);
                    !this.rbploading.improvements ? ++this.loadingCount : null;
                } else {
                    this.rbploading.proposedImprovements = !this.task.getFileId(CONST.__RESOURCETYPE_DXF, CONST.__IDENTIFIERTYPE_STEERINGLINE);
                    !this.rbploading.proposedImprovements ? ++this.loadingCount : null;
                }
            }

            // production if has group 2
            if (this.hasTracking) {
                this.rbploading.production = false;
                this.rbploading.productiontable = false;
                this.loadingCount += 2;
            }
        },
        openSurvey() {
            this.getSurveyProduction();
        },
        async getSurveyProduction() {
            try {
                if (this.loading) this.loading.setText(this.language.t("Map.loadingSurvey"));
                if (this.loading) this.loading.minimize();

                if (this.loading) this.loading.addProgress(33);
                const { data: survey } = await this.$axios.get(route("api.tasks.opensurvey", this.task.taskId));

                if (this.loading) this.loading.addProgress(66);
                var timepositions = {};

                survey.forEach((production) => {
                    if (production.surveytimepositionlogId) {
                        Object.assign(timepositions, { [production.surveytimepositionlogId]: production.timepositions });
                    } else {
                        Object.assign(timepositions, { [production.rptimepositionlogId]: production.timepositions });
                    }
                });

                this.mapTaskInfo.getChildElement("SURVEY").drawLayer(timepositions, this.task.projection);
                this.map.fitExtend(this.mapTaskInfo.getExtent());

                this.$emit("updateLayerlist");

                if (this.loading) this.loading.hide();
            } catch (err) {
                console.error("Could not get survey production: " + err);
            }
        },
        checkRBPProduction() {
            console.log("CHECK PRODUCTION")
            this.$axios.get(route("api.task.production.check", this.task.taskId)).then(res => {
                // no production exists for this task
                if (!res.data) {
                    this.rbploading.production = true;
                    this.rbploading.productiontable = true;
                }
                else if (!this.hasTracking) {
                    this.rbpProductionTable.productionTablePlaceholder();
                }
                this.rbploading.checkProduction = true;
            }).catch((error) => {
                console.error(error);
                this.rbploading.checkProduction = true;
            });
        },
        //weird function
        async getRBPProduction() {
            console.log("GET PRODUCTION");
            try {
                if (this.loading) this.loading.setText(this.language.t("Map.loadingProductionData"));
                const { data: logs } = await this.$axios.get(route("api.task.production.logs", this.task.taskId));


                const lines = { rptimepositionlogs: [] };
                const points = { rptimepositionlogs: [] };
                const drivinglines = { rptimepositionlogs: [] }

                if (logs.rptimepositionlogs) {
                    if (this.task == null) return; // task is closed in the meantime
                    logs.rptimepositionlogs.forEach((production) => {
                        switch (production.roadplottertaskstateId) {
                            case CONST.__RP_STATE_SPRAY_ON:
                                lines.rptimepositionlogs.push(production.rptimepositionlogId);
                                break;
                            case CONST.__RP_STATE_POINT:
                                points.rptimepositionlogs.push(production.rptimepositionlogId);
                                break;
                            case CONST.__RP_STATE_IDLE:
                            case CONST.__RP_STATE_TASK_ON:
                                drivinglines.rptimepositionlogs.push(production.rptimepositionlogId);
                                break;
                        }
                    });

                    if (drivinglines.rptimepositionlogs.length > 0) {
                        try {
                            const driveLines = await this.getRpTimePositionLogs(drivinglines.rptimepositionlogs);
                            this.mapTaskInfo.getChildElement("RBPDRIVINGLINES").drawLayer(driveLines, this.task.projection);
                            // this.map.fitExtend(this.mapTaskInfo.getExtent()); // fit to extend?
                        } catch (error) {
                            console.error(error)
                        }
                    }

                    if (lines.rptimepositionlogs.length > 0 || points.rptimepositionlogs.length > 0) {
                        this.mapTaskInfo.getChildElement("RBPPRODUCTION").drawLayer(this.task.projection);
                    }

                    if (lines.rptimepositionlogs.length > 0) {
                        try {
                            const steeringlines = await this.getRpTimePositionLogs(lines.rptimepositionlogs);
                            this.mapTaskInfo.getChildElement("RBPPRODUCTION").addSteeringlines(steeringlines);
                        } catch (error) {
                            console.error(error)
                        }
                    }

                    if (points.rptimepositionlogs.length > 0) {
                        try {
                            const sprayedPoints = await this.getRpTimePositionLogs(points.rptimepositionlogs);
                            this.mapTaskInfo.getChildElement("RBPPRODUCTION").addSprayPoints(sprayedPoints);
                            // this.map.fitExtend(this.mapTaskInfo.getExtent());
                        } catch (error) {
                            console.error(error)
                        }
                    }
                } else { //no positions?
                    this.rbploading.productiontable = true;
                    this.rbploading.production = true;
                }

                this.rbploading.production = true;
            } catch (err) {
                this.$emit("onAddAlert", "opentask", this.language.t("Map.productionAlert"), "warning", true);
                this.rbploading.production = true;
                console.error("Could not get task production: " + err);
            }
        },
        async getRpTimePositionLogs(rptimepositionlogIds) {
            var deferreds = {};
            var rptimepositionlogsToHandle = [];
            var maxRpTimePositionlogsToHandle = 100;
            var rpTimePositionLogsHandled = 0;
            var promises = [];

            // Iteratie over RpTimePositionLogs
            var i = 0;
            var len = rptimepositionlogIds.length;
            for (let j = 0; j < rptimepositionlogIds.length; j++) {
                rptimepositionlogsToHandle.push(rptimepositionlogIds[j]);
                rpTimePositionLogsHandled++;

                if (rpTimePositionLogsHandled > maxRpTimePositionlogsToHandle || i === len - 1) {
                    promises.push(this.addRpTimePositionLogs(rptimepositionlogsToHandle).then(res => {
                        deferreds = Object.assign(deferreds, res);
                    }));
                    rptimepositionlogsToHandle = [];
                    rpTimePositionLogsHandled = 0;
                }
                i++;
            }
            await Promise.all(promises)
            return deferreds;
        },

        async addRpTimePositionLogs(rptimepositionlogIds) {
            const { data: positions } = await this.$axios.get(route("api.production.rbp.positions"), { params: { rptimepositionlogs: rptimepositionlogIds } });
            return positions;
        },

        getRBPProductionTable() {
            console.log("GET PRODUCTION TABLE");

            if (this.rbpProductionTable) {
                if (this.loading) this.loading.setText(this.language.t("Map.loadingProductionData"));
                this.rbpProductionTable.getProduction(null, this.task.taskId, null, null, "GEO", this.RBProductionTableLoaded);
            }
        },

        RBProductionTableLoaded(success) {
            if (!success && this.task != null) {
                this.$emit("onAddAlert", "opentask", this.language.t("Map.productionTableAlert"), "warning", true);
            }
            this.rbploading.productiontable = true;
        }
    },
};
</script>

<style>
#map {
    width: 100%;
    height: 100%;
}

.rotate-north {
    top: 65px;
    left: 0.5em;
}

.ol-touch .rotate-north {
    top: 80px;
}

.layer-switcher .panel {
    background-color: var(--v-base-base) !important;
    color: var(--v-text-base);
}

.ol-attribution:not(.ol-collapsed) {
    background-color: var(--v-base-base) !important;
}

.ol-attribution ul {
    color: var(--v-text-base);
}

.ol-zoom {
    top: unset;
    left: unset;
    right: 8px;
    bottom: 8px;
}
</style>